export default "__VITE_ASSET__TjDzKm4r__"